let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aU7v8")).then(() => parcelRequire('gCIxF'));